import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import './styles.scss';


class PaginationRow extends React.Component {
  constructor(props) {
    super(props);
  }

  handleClick = (e) => {
    e.preventDefault();
    this.props.handlePaginate(this.props.page);
  };

  render() {
    if (!this.props.isActive) return null;
    return (
      <li className='ov-pagination-active'>
        <a href={this.props.url} onClick={this.handleClick}>{this.props.page}</a>
      </li>
    );
  }
}




class Pagination extends React.Component {
  constructor(props) {
    super(props);
  }

  handlePaginateFirstPage = (e) => {
    e.preventDefault();
    this.props.handlePaginate(0)
  };

  handlePaginateLastPage = (e) => {
    e.preventDefault();
    this.props.handlePaginate(this.props.numPages)
  };

  render() {
    let { currentPage, numRecords, numPages, baseUrl} = this.props;
    let pages = [];

    // Current page always starts from 1
    if (currentPage === 0) currentPage = 1;

    if (3 >= currentPage) {
      pages = range(1, 6);
    } else {
      pages = [currentPage-2, currentPage-1, currentPage,
        currentPage+1, currentPage+2];
    }

    let numRecordsText = '';
    if (numRecords === 1) {
      numRecordsText = `(${numRecords} result)`;
    } else {
      numRecordsText = `(${numRecords.toLocaleString()} results)`;
    }

    pages = pages.filter((page) => numPages >= page && page > 0);
    let pageCountText = `Page ${currentPage} of ${numPages} ${numRecordsText}`;

    const firstPageUrl = baseUrl ? baseUrl + "?page=1" : "javascript:;";
    const lastPageUrl = baseUrl ? baseUrl + "?page=" + numPages : "javascript:;";

    if (numRecords === 0) return null;
    if (!this.props.displaySinglePage && 1 >= numPages) return null;

    return (
      <div className="ov-pagination">
        <div className="ov-pagination-count">{pageCountText}</div>
        <ul className="ov-pagination-content">
            <li>
              <a href={firstPageUrl} aria-label="First" onClick={this.handlePaginateFirstPage}>
                <Icon.Fa icon="angle-double-left" />
              </a>
            </li>

              {pages.map((page) =>
                <PaginationRow
                  key={uniqueId()}
                  handlePaginate={this.props.handlePaginate}
                  url={baseUrl ? baseUrl + "?page=" + page : "javascript:;"}
                  page={page}
                  isActive={page===currentPage}
                />
              )}

            <li>
              <a href={lastPageUrl} aria-label="Last" onClick={this.handlePaginateLastPage}>
                <Icon.Fa icon="angle-double-right" />
              </a>
            </li>
        </ul>
      </div>
    );
  }
}




Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  numPages: PropTypes.number.isRequired,
  numRecords: PropTypes.number.isRequired,
  handlePaginate: PropTypes.func,
  baseUrl: PropTypes.string,
  displaySinglePage: PropTypes.bool, // If we should show pagination when there's only 1 page
};



Pagination.defaultProps = {
  handlePaginate: ()=>{},
  baseUrl: '',
  displaySinglePage: true,
};



export { Pagination };
